// extracted by mini-css-extract-plugin
export default {"tours":"TourItem_tours__Kq4Ti"};